import { render, staticRenderFns } from "./TiposProcesos.view.vue?vue&type=template&id=1e98508e"
import script from "./TiposProcesos.view.vue?vue&type=script&lang=js"
export * from "./TiposProcesos.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports